<template>
  <v-flex xs12>
    <v-flex xs12>
      <v-text-field
        prepend-icon="check"
        :prepend-icon-cb="changeState"
        label="Nombre del item"
        v-model="structureItemData.itemName"
      ></v-text-field>
    </v-flex>

    <v-flex xs10 offset-xs2>
      <v-text-field
        label="Descripcion del item"
        v-model="structureItemData.description"
      ></v-text-field>
    </v-flex>

    <v-flex xs10 offset-xs2>
      <v-text-field
        label="Etiquetas del item"
        v-model="structureItemData.labels"
      ></v-text-field>
    </v-flex>

    <v-flex xs10 offset-xs2>
      <v-text-field
        label="Url de vista previa"
        v-model="structureItemData.imageUrl"
        clearable
      ></v-text-field>
    </v-flex>
  </v-flex>
</template>

<script>
export default {
  name: 'structure-item',
  methods: {
    changeState () {
      console.warn('change state')
    }
  },
  props: {
    structureItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/structures/structure-item.vue